import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';

@Component({
  selector: 'app-anchor-section',
  imports: [],
  templateUrl: './anchor-section.component.html',
  styleUrl: './anchor-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnchorSectionComponent {
  public readonly anchor = input.required<string>();

  @HostBinding('attr.id')
  public get id(): string {
    return this.anchor();
  }
}
